/**
 * @description: Sets the homepage text.
 * @requires {Object} configService
 */
function mainViewController(configService, $window) {

  const vm = this;

  vm.header = configService.messages.tracking_code.header;
  vm.desc = configService.messages.tracking_code.description;
  $window.scrollTo(0, 0);

}

export default mainViewController;



// WEBPACK FOOTER //
// ./src/controllers/main-view.controller.js